import { FetcherResult } from "../api-client/fetcher";
import { GetHookResult, useGet } from "../api-client/useGet";
import { useNullableCampaignInfo } from "../stores/hooks/useNullableCampaignInfo";
import { useNullableNationalAccountInfo } from "../stores/hooks/useNullableNationalAccountInfo";
import { useUpgradeToken } from "../stores/hooks/useUpgradeToken";
import { Token } from "../stores/slices/authSlice";

export const useGetSecurityToken = (): GetHookResult => {
  const { get, isLoading } = useGet();
  const nationalAccount = useNullableNationalAccountInfo();
  const campaign = useNullableCampaignInfo();
  const upgradeToken = useUpgradeToken();

  const enhancedGet = async <T = Token>(
    dealerId: string
  ): Promise<FetcherResult<T>> => {
    const response = await get<T>(
      "/retailSiteWebService/authentication/getSecurityToken.php",
      {
        campaignId: campaign?.campaign.campaignId ?? "",
        dealerId,
        isNational: "1",
        nationalAccountCode: nationalAccount?.nationalAccountUrlCode ?? "",
        password: "",
        userIpAddress: window.ipAddress,
        username: "",
      }
    );
    upgradeToken(response.token);
    return response;
  };

  return {
    get: enhancedGet,
    isLoading,
  };
};
